module.exports = __webpack_public_path__ + "media/reskin-images/icon--chevron-left-37387cea.svg";